// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__rZZCX","description":"checkbox_description__kN7EK","readonly":"checkbox_readonly__0jtZa"};